
import { ApiService } from "./api.service";
import { Router } from "@angular/router";

import { Injectable } from '@angular/core';
import { LegalDomainModel } from "@bt/core";
//import { Observable, of } from 'rxjs';
import { IResponse } from "@bt/shared";

@Injectable()
export class LegalDomainService{

    constructor(private api: ApiService,
                private router: Router,){}


    public CreateOrEditLegalDomain(legalDomainModel: LegalDomainModel): Promise<IResponse<boolean>>{
        return this.api.post<boolean>("api/legaldomain/createoredit",legalDomainModel).toPromise();
    }

    public GetLegalDomain(): Promise<IResponse<LegalDomainModel[]>>{
        return this.api.get<LegalDomainModel[]>("api/legaldomain/getall").toPromise();
    }

    public DeleteLegalDomain(domainToDel: LegalDomainModel[]): Promise<IResponse<boolean>> {
        return this.api.put<boolean>("api/legaldomain/todelete", domainToDel).toPromise();
    }

}



// WEBPACK FOOTER //
// ./src/app/core/services/legal-domain.service.ts